import React, { useState, useEffect } from "react"; // Importe useEffect
import Clients from "../components/Clients";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Intro from "../components/Intro";
import heroImg from "../images/barco-an.png";

// Constante do breakpoint (padrão Tailwind)
const MD_BREAKPOINT = 768;

const Home = () => {
  const [heroHeight, setHeroHeight] = useState(0); 
  // NOVO: Estado para saber se a tela é grande (>= 768px)
  const [isLargeScreen, setIsLargeScreen] = useState(true); 
  
  // 1. Monitorar o breakpoint
  useEffect(() => {
    // Checa se a largura é >= 768px (MD_BREAKPOINT)
    const mediaQuery = window.matchMedia(`(min-width: ${MD_BREAKPOINT}px)`);

    const handleMediaQuery = (e) => {
      // e.matches é true se a tela for grande (>= 768px)
      setIsLargeScreen(e.matches); 
    };

    handleMediaQuery(mediaQuery);
    mediaQuery.addListener(handleMediaQuery);

    return () => mediaQuery.removeListener(handleMediaQuery);
  }, []); 

  const handleHeroHeightChange = (height) => {
    setHeroHeight(height);
  };

  // 2. Lógica Condicional para wrapperMinHeight
  const wrapperMinHeight = isLargeScreen 
    ? null // 💡 Se a tela é grande (>= 768px), não aplicamos o estilo 'minHeight'. O CSS padrão (100vh) será usado.
    : heroHeight > 0 
      ? `${heroHeight + 350}px` // Se for tela pequena (< 768px), usamos o cálculo dinâmico.
      : '1946px'; // Fallback em telas pequenas se heroHeight ainda for 0.

  // NOTE: Se você quiser garantir 100vh exato em telas grandes via React, 
  // mude a linha 36 para: ? '100vh' : ...

  // A maneira mais limpa é deixar o CSS padrão (100vh) prevalecer, usando `null`.
  
  return (
    <>
      <div className="">
        <div 
          className={"animation-wrapper"}
          style={wrapperMinHeight ? { minHeight: wrapperMinHeight } : {}} // 3. Aplicação condicional
        >
          {/* ... Animação ... */}
          <div className="water">
            <ul className="waves">
              <li
                className="wave-one"
                style={{
                  backgroundImage: 'url("/images/wave1.png")',
                }}
              />
              <li
                className="wave-two"
                style={{
                  backgroundImage: 'url("/images/wave2.png")',
                }}
              />
              <li
                className="wave-three"
                style={{
                  backgroundImage: 'url("/images/wave3.png")',
                }}
              />
              <li
                className="wave-four"
                style={{
                  backgroundImage: 'url("/images/wave4.png")',
                }}
              />
            </ul>
          </div>
          <div
            className="boat"
            style={{
              backgroundImage: 'url("'+heroImg+'")',
            }}
          />
          <div
            className="cloud"
            style={{
              backgroundImage: 'url("https://i.postimg.cc/VNkrLZCV/cloud-md.png")',
            }}
          />
          <div
            className="cloud2"
            style={{
              backgroundImage: 'url("https://i.postimg.cc/VNkrLZCV/cloud-md.png")',
            }}
          />
        </div>
      </div>
      <Hero onHeightChange={handleHeroHeightChange} /> 
      <Intro />
      <Clients />
      <Footer />
    </>
  );
};

export default Home;